import { ComponentPropsWithRef } from 'react';
import { useVisuallyHidden } from 'react-aria';

export const ScreenReaderOnly = (props: ComponentPropsWithRef<'span'>) => {
  const { visuallyHiddenProps } = useVisuallyHidden();

  return <span {...visuallyHiddenProps} {...props} />;
};
